export default {
  theme: {
    accent: '#1976d2',
  },
};



// WEBPACK FOOTER //
// ./src/plugins/options/vuetify.js